import { render, staticRenderFns } from "./CategoryTopItemsCarousel.vue?vue&type=template&id=581c1563&scoped=true&"
import script from "./CategoryTopItemsCarousel.vue?vue&type=script&lang=js&"
export * from "./CategoryTopItemsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTopItemsCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CategoryTopItemsCarousel.vue?vue&type=style&index=1&id=581c1563&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c1563",
  null
  
)

export default component.exports